import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'toFormControl',
    standalone: false
})
export class FormControlPipe implements PipeTransform {

  transform<T>(abstractControl: any): T {
      return abstractControl as T;
  }

}
